<template>
  <section id="Header">
    <h1>2020 YEAR IN CALLING</h1>
    <div>A look back on how the world communicated using Truecaller</div>
    <div id="scroll">
      SCROLL
      <br />
      <img src="@/assets/icons/scroll-icon.svg" />
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
#Header {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("../assets/images/year_in_calling_truecaller_2020_1.jpeg");
  background-size: cover;
  background-position: center center;
  padding: 20px;
  position: relative;
}

#Header > h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 30px;
  line-height: 37px;
  letter-spacing: -1.03px;
}

#Header > div {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: -1.03px;
  max-width: 420px;
}

#scroll {
  position: absolute;
  font-family: "Montserrat", sans-serif;
  font-size: 16px !important;
  font-weight: 600;
  bottom: 24px;
}
#scroll img {
  width: 18px;
  height: 18px;
  animation: scrolldown 1.25s infinite;
}

@media screen and (min-width: 720px) {
  #Header > h1 {
    font-size: 60px;
    line-height: 73px;
    letter-spacing: -2.07px;
  }

  #Header > div {
    font-size: 24px;
    line-height: 26px;
    letter-spacing: 0;
  }
}

@keyframes scrolldown {
  to {
    transform: translateY(55%);
    opacity: 0;
  }
}
</style>